import { useState } from 'react';
import './Header.scss';
import downloadIcon from '../../src/assets/images/download.svg';
import mailIcon from '../../src/assets/images/email.svg';
import EmailBlade from '../QuoteDetail/EmailBlade';
import { useNavigate } from 'react-router-dom';

interface PropData {
    data?: any;
    code?: string;
    quote?: string;
    serviceMaster?: string;
    isSignHeader?: boolean;
    isCheckList?: boolean;
    title?: string
    receipt?: boolean;
    onTermsClick?: any;
    onDownloadClick?: any;
}

const QuoteHeader = (props: PropData) => {
    const [emailModal, setShowEmailModal] = useState(false)
    const navigate = useNavigate();
 console.log(props);
    const closeEmailBlade = () => {
        setShowEmailModal(false)
    }
    return (
        <>
            {
               
                props.isSignHeader === true ?
                    <div className='header'>
                        <div className='p-4'>
                            <div className='invoice-title'>Sign Quote</div>
                        </div>
                    </div>
                    :
                    props.isCheckList == true ?
                        <div className='header'>
                            <div className='p-4'>
                                <div className='invoice-title'>{props.title}</div>
                            </div>
                        </div>
                        :
                        <>
                            <EmailBlade
                                isShow={emailModal}
                                isClose={closeEmailBlade}
                                data={props?.data}
                                code={props.code ? props.code : ''}
                                quoteNum={props.quote ? props.quote : ''}
                            />
                            <div className='header'>
                                <div className='d-flex justify-content-between p-4'>
                                    <div className='invoice-title'>Quote</div>
                                    {
                                        props?.data &&
                                        <div className={props.receipt ? 'd-none' : ''}>
                                            <span className='termsConditionText' onClick={() => props.onTermsClick()}>Terms & Conditions</span>
                                            <img src={downloadIcon} className='ms-2 cursor-pointer' onClick={() => props.onDownloadClick()} />
                                        </div>
                                    }
                                </div>
                            </div>
                        </>
            }
        </>
    )
}

export default QuoteHeader;